export const size = {
  xs: 375,
  sm: 720,
  md: 1024,
  lg: 1440,
}

export const device = {
  xs: `(min-width: ${size.xs}px)`,
  sm: `(min-width: ${size.sm}px)`,
  md: `(min-width: ${size.md}px)`,
  lg: `(min-width: ${size.lg}px)`,
}
